export enum components {
  mainRepeater = '#repeater1',
  dayText = '#slotsDate',
  slotRepeater = '#innerRepeater1',
}
